export const ids = ['area', 'length', 'height', 'volume', 'pitch'] as const;
